<template>
    <div>
        <nav class="navbar">
            <div class="container-fluid">
                <a class="navbar-brand" href="//meine-landausfluege.de">
                    <img alt="Brand"
                         src="//cdn.meine-landausfluege.de/wp-content/themes/excursions/assets/images/logo-brand.jpg">
                </a>
                <h2 class="text-center">{{ $t('widgetHeader') }}</h2>
            </div>
        </nav>
        <ul class="nav nav-pills">
            <li class="nav-item">
                <a class="nav-link" href="//meine-landausfluege.de/impressum/">{{ $t('imprint') }}</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="//meine-landausfluege.de/datenschutz/">{{ $t('dataProtection') }}</a>
            </li>
        </ul>

        <div class="alert alert-warning" role="alert">
            {{ $t('simpleMethodDescription') }}
            <br>
            <br>
            <span v-html="$t('pleaseContactUsShort')"></span>
        </div>
    </div>


</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped>

</style>